export const HTTP_NOT_FOUND = 404;
export const HTTP_LOGIN_TIMEOUT = 440;
export const HTTP_BAD_REQUEST = 400;
